// The user's (or organisation's) landing view is stored as a namespaced string and resolved to a
// route here. Keep this the single place that knows the value format so the settings picker, the
// login redirect and any future consumer stay in step.

export const DEFAULT_HOME_ROUTE = '/dashboard';

// The default analytics tabs a user can pick as their home. The page resolves ?tab=<key> via
// parseAnalyticsViewParams (shared/utils/analytics-view-utils.ts): the per-dimension keys (group,
// subsidiary, ...) land on the Emissions tab with that dimension preselected, so saved choices
// survive both the tab collapse and org feature flags.
export const ANALYTICS_HOME_TABS: { key: string; label: string }[] = [
  { key: 'overview', label: 'Analytics: Overview' },
  { key: 'energy', label: 'Analytics: Energy' },
  { key: 'group', label: 'Analytics: Emissions by Group' },
  { key: 'subsidiary', label: 'Analytics: Emissions by Subsidiary' },
  { key: 'location', label: 'Analytics: Emissions by Location' },
  { key: 'supplier', label: 'Analytics: Emissions by Supplier' },
  { key: 'project', label: 'Analytics: Emissions by Project' },
  { key: 'surveys', label: 'Analytics: Surveys' },
  { key: 'flag', label: 'Analytics: FLAG' },
];

export const CUSTOM_DASHBOARD_PREFIX = 'custom-dashboard:';
export const ANALYTICS_TAB_PREFIX = 'analytics:';

export function customDashboardHomeValue(dashboardId: string): string {
  return `${CUSTOM_DASHBOARD_PREFIX}${dashboardId}`;
}

export function analyticsTabHomeValue(tabKey: string): string {
  return `${ANALYTICS_TAB_PREFIX}${tabKey}`;
}

// Turns a stored home-view value into a route. Falls back to the standard dashboard for an empty
// or unrecognised value, so a deleted custom dashboard never leaves a user stranded.
export function resolveHomeRoute(homeView?: string | null): string {
  if (!homeView) return DEFAULT_HOME_ROUTE;
  if (homeView.startsWith(CUSTOM_DASHBOARD_PREFIX)) {
    const id = homeView.slice(CUSTOM_DASHBOARD_PREFIX.length);
    return id ? `/analytics/custom-dashboards/${id}` : DEFAULT_HOME_ROUTE;
  }
  if (homeView.startsWith(ANALYTICS_TAB_PREFIX)) {
    const key = homeView.slice(ANALYTICS_TAB_PREFIX.length);
    return key ? `/analytics/dashboard?tab=${key}` : DEFAULT_HOME_ROUTE;
  }
  return DEFAULT_HOME_ROUTE;
}
